
      // this file is automatically generated by git.version.ts script
      export const versions = {
        version: '0.0.0',
        revision: '7d32387',
        branch: 'feature/MIFS-510'
      };